import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GECKO_CONSTS, GeckoField } from 'ui';
import './index.scss';

class RelativeTime extends Component {
  static propTypes = {
    value: PropTypes.shape({
      value: PropTypes.number,
      unit: PropTypes.oneOf(['seconds', 'minutes', 'hours', 'days']),
      seconds: PropTypes.number,
    }),
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || {
        value: null,
        unit: 'seconds',
        seconds: null,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
      this.setState({ value: this.props.value });
    }
  }

  valueField = {
    key: 'value',
    type: GECKO_CONSTS.FIELD_TYPE_NUMBER,
  };

  unitField = {
    key: 'unit',
    type: GECKO_CONSTS.FIELD_TYPE_SELECT,
    options: [
      {
        label: 'Seconds',
        value: 'seconds',
      },
      {
        label: 'Minutes',
        value: 'minutes',
      },
      {
        label: 'Hours',
        value: 'hours',
      },
      {
        label: 'Days',
        value: 'days',
      },
    ],
    config: {
      clearable: false,
    },
  };

  handler(key, value) {
    const newValue = Object.assign({}, this.state.value, { [key]: value });
    if (newValue.value) {
      const unitMap = {
        seconds: 1,
        minutes: 60,
        hours: 60 * 60,
        days: 24 * 60 * 60,
      };
      newValue.value = Number(newValue.value);
      newValue.seconds = newValue.value * unitMap[newValue.unit];
    }
    this.setState({ value: newValue }, () => {
      // If we have a unit and a value we can trigger the onChange
      if (this.state.value.unit && this.state.value.value) {
        this.props.onChange(this.state.value);
      }
    });
  }

  render() {
    return (
      <div className="RelativeTime">
        <GeckoField
          field={this.valueField}
          values={this.state.value}
          handler={this.handler.bind(this)}
        />
        <GeckoField
          field={this.unitField}
          values={this.state.value}
          handler={this.handler.bind(this)}
        />
      </div>
    );
  }
}

export default RelativeTime;
